import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _784c4d0e = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _01911c66 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _26d43e69 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _6586edcf = () => interopDefault(import('../pages/search/documents.vue' /* webpackChunkName: "pages/search/documents" */))
const _7c73bcc6 = () => interopDefault(import('../pages/search/products.vue' /* webpackChunkName: "pages/search/products" */))
const _5d9b6d84 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7695abc6 = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))
const _d3b8c830 = () => interopDefault(import('../pages/documents/_slug/index.vue' /* webpackChunkName: "pages/documents/_slug/index" */))
const _4fa73a0c = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _041a851c = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _5be4cc3c = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/catalog",
    component: _784c4d0e,
    name: "catalog___en"
  }, {
    path: "/search",
    component: _01911c66,
    children: [{
      path: "",
      component: _26d43e69,
      name: "search___en"
    }, {
      path: "documents",
      component: _6586edcf,
      name: "search-documents___en"
    }, {
      path: "products",
      component: _7c73bcc6,
      name: "search-products___en"
    }]
  }, {
    path: "/",
    component: _5d9b6d84,
    name: "index___en"
  }, {
    path: "/catalog/:slug",
    component: _7695abc6,
    name: "catalog-slug___en"
  }, {
    path: "/documents/:slug",
    component: _d3b8c830,
    name: "documents-slug___en"
  }, {
    path: "/news/:slug?",
    component: _4fa73a0c,
    name: "news-slug___en"
  }, {
    path: "/product/:slug?",
    component: _041a851c,
    name: "product-slug___en"
  }, {
    path: "/:slug",
    component: _5be4cc3c,
    name: "slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
